export const AddAltIcon = ({ color = "#282828", size = 16, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <line x1="12.3999" y1="8.19043" x2="3.0999" y2="8.19043" stroke={color} />
        <line x1="7.56006" y1="12.6504" x2="7.56006" y2="3.35039" stroke={color} />
        <circle cx="7.75" cy="8" r="7.25" transform="rotate(90 7.75 8)" stroke={color} />
    </svg>
);
